export type SseFrame = { data: string } | { retryMs: number };

/**
 * Incremental parser for a text/event-stream body. Chunks arrive at arbitrary
 * boundaries, so state carries across `feed` calls. Only the `data` and `retry`
 * fields matter to us: the backend dispatches by a type inside the JSON payload
 * and never sets `event` or `id`, and comment lines are its heartbeats.
 */
export class SseParser {
  private buffer = '';
  private dataLines: string[] = [];

  public feed(chunk: string): SseFrame[] {
    this.buffer += chunk;
    const frames: SseFrame[] = [];

    let newline = this.buffer.indexOf('\n');
    while (newline >= 0) {
      let line = this.buffer.slice(0, newline);
      this.buffer = this.buffer.slice(newline + 1);
      if (line.endsWith('\r')) {
        line = line.slice(0, -1);
      }

      if (line === '') {
        if (this.dataLines.length > 0) {
          frames.push({ data: this.dataLines.join('\n') });
          this.dataLines = [];
        }
      } else if (!line.startsWith(':')) {
        const colon = line.indexOf(':');
        const field = colon === -1 ? line : line.slice(0, colon);
        let value = colon === -1 ? '' : line.slice(colon + 1);
        if (value.startsWith(' ')) {
          value = value.slice(1);
        }
        if (field === 'data') {
          this.dataLines.push(value);
        } else if (field === 'retry') {
          const ms = Number(value);
          if (Number.isInteger(ms) && ms >= 0) {
            frames.push({ retryMs: ms });
          }
        }
      }

      newline = this.buffer.indexOf('\n');
    }

    return frames;
  }
}
